import { render, staticRenderFns } from "./SettlePersonInfo.vue?vue&type=template&id=6e22e24c&scoped=true&"
import script from "./SettlePersonInfo.vue?vue&type=script&lang=js&"
export * from "./SettlePersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettlePersonInfo.vue?vue&type=style&index=0&id=6e22e24c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22e24c",
  null
  
)

export default component.exports